import {
  Row,
  Col,
  Button,
  Stack,
  Container
} from '@leroy-merlin-br/backyard-react-ui'
import { useHistory } from 'react-router-dom'

import * as S from './styled'

function Success () {
  const history = useHistory()

  return (
    <S.Content>
      <Container>
        <S.Card>
          <Row>
            <Col size={{ giga: 4 }}>
              <S.WrapperImage>
                <img
                  src={`${
                    window && window.env.assetHost
                  }assets/images/signup/check.svg`}
                  alt="check"
                />
              </S.WrapperImage>
              <Stack spacing="kilo">
                <S.Title size="tera" noMargin>
                  Tudo pronto, conta criada!
                </S.Title>
                <S.SubTitle size="mega">
                  Agora que você já é de casa, fique a vontade para aproveitar
                  todas as funcionalidades do nosso site feitas para te ajudar a
                  deixar o seu ambiente do jeitinho que você sempre sonhou!
                </S.SubTitle>
                <Row>
                  <Col size={{ giga: 10 }}>
                    <Button
                      isStretch
                      as="a"
                      href={history.location.state.redirect}
                      data-cy="button-success"
                    >
                      Continuar
                    </Button>
                  </Col>
                </Row>
              </Stack>
            </Col>
          </Row>
        </S.Card>
      </Container>
    </S.Content>
  )
}

export default Success
